export default "__VITE_ASSET__DLqdJje7__"